var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackrsLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 304,
    viewBox: "0 0 272 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.739 33.246C210.354 33.246 271.076 93.952 271.076 168.566C271.076 243.198 210.353 303.903 135.739 303.903C61.1073 303.903 0.402344 243.197 0.402344 168.566C0.402344 108.082 40.3033 56.746 95.1723 39.458V0.717041H115.652V34.748C122.205 33.758 128.912 33.246 135.739 33.246ZM250.597 168.566C250.597 105.249 199.073 53.725 135.739 53.725C128.878 53.725 122.171 54.356 115.652 55.517V250.4H95.1723V61.15C51.8063 77.585 20.8813 119.517 20.8813 168.567C20.8813 231.901 72.4053 283.425 135.739 283.425C199.073 283.425 250.597 231.9 250.597 168.566Z",
    fill: "#002760"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.74 86.75C180.932 86.75 217.574 123.375 217.574 168.567C217.574 213.759 180.932 250.4 135.74 250.4V196.333C151.066 196.333 163.49 183.909 163.49 168.566C163.49 153.24 151.066 140.816 135.74 140.816V86.75Z",
    fill: "#002760"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.739 180.959C142.583 180.959 148.132 175.411 148.132 168.566C148.132 161.722 142.583 156.173 135.739 156.173C128.894 156.173 123.346 161.722 123.346 168.566C123.346 175.411 128.894 180.959 135.739 180.959Z",
    fill: "#FF5B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackrsLogoSmall);
export default __webpack_public_path__ + "static/media/backrs-logo-small.d69f33c6c6898086bb9cc8d05e3fb1d0.svg";
export { ForwardRef as ReactComponent };